import Form from 'vform';
import deleteItem from "@/mixins/deleteItem";
import {merge} from 'lodash';

export default {
    mixins: [deleteItem],
    props: {
        id: {
            type: [Number, String],
            default: null,
        },
    },
    data() {
        return {
            lazy: false,
            pending: false,
            item: new Form(),
            showRevisions: false,
            breadcrumb: []
        };
    },
    computed: {
        // resourceName() {
        //     throw new Error('Please implement the "resourceName" computed property');
        // },
        redirectAfterCreate() {
            return false;
        },
        baseUrl() {
            return `/api/${this.resourceName}`;
        },
        itemUrl() {
            return `${this.baseUrl}/${this.id}`
        },
        revisionsUrl() {
            return `${this.itemUrl}/revisions`
        },
        duplicateUrl() {
            return `${this.itemUrl}/duplicate`
        },
    },
    beforeRouteLeave(to, from, next) {
        this.setTitle([]);
        this.breadcrumb = []
        next();
    },
    watch: {
        '$route': 'fetchData',
        breadcrumb: 'setTitle',
    },
    created() {
        if (!this.lazy) {
            this.fetchData();
        }

        this.listenForLockEvents();
    },

    beforeDestroy() {
        this.$echo.leave('model_locking');
    },

    methods: {
        fetchData() {
            if (this.pending) {
                return;
            }

            if (!this.id) {
                this.item.reset();
                return;
            }

            this.pending = true;

            this.axios
                .get(this.itemUrl)
                .then(({data}) => {
                    this.setBreadcrumb(data.data || data);
                    this.setData(data.data || data)
                })
                .catch(e => {
                    if (!e.response) {
                        throw e;
                    }
                })
                .finally(() => {
                    this.pending = false;
                })

        },

        async handleSave() {
            if (this.item.busy) {
                return;
            }

            if (this.id) {
                this.handleUpdate();
            } else {
                this.handleCreate();
            }
        },

        handleCreate() {
            this.item.post(this.baseUrl)
                .then(({data}) => {
                    this.$root.$emit(`created::${this.resourceName}`, data);
                    this.$emit('created', data);

                    if (this.redirectAfterCreate && data) {
                        this.$router.push({
                            name: `${this.resourceName}.show`,
                            params: {
                                id: data.id,
                            },
                        })
                    } else {
                        this.item.reset();
                    }

                    this.afterCreate();

                    this.savedToast();
                })
                .catch(e => e.response || throw e);

        },

        handleUpdate() {
            this.item.put(this.itemUrl)
                .then(({data}) => {
                    this.$root.$emit(`updated::${this.resourceName}`, data || this.item.data());

                    if (data) {
                        this.setData(data);
                    }

                    this.savedToast();

                    this.afterUpdate();
                })
                .catch(e => e.response || throw e);
        },

        listenForLockEvents() {
            this.$echo.channel('model_locking')
                .listen('.ModelLocked', (e) => {
                    if (this.item.model_name !== e.model.model_name) return;
                    if (this.item.id !== e.model.id) return;

                    this.setData(merge(this.item, e.model))
                })
                .listen('.ModelUnlocked', (e) => {
                    if (this.item.model_name !== e.model.model_name) return;
                    if (this.item.id !== e.model.id) return;

                    this.setData(merge(this.item, e.model))
                })
        },

        setBreadcrumb(data) {
            this.breadcrumb = [
                {
                    text: this.$t('Projects'),
                    to: {name: 'projects.index'}
                }
            ].concat(data.breadcrumb || []);
        },

        setData(data) {
            this.item = new Form(data);
        },

        setTitle(breadcrumb) {
            const title = document.querySelector('title');
            if (!title.dataset.originalTitle) {
                title.dataset.originalTitle = title.text;
            }

            let breadcrumbText = breadcrumb.map(b => b.text);

            if (breadcrumbText.length > 1) {
                breadcrumbText.shift();
            }

            breadcrumbText.unshift(title.dataset.originalTitle);

            this.$nextTick(() => {
                document.title = breadcrumbText.join(' | ');
            });
        },

        afterDelete() {
            this.$router.push({
                name: `${this.resourceName}.create`,
            });
        },

        afterCreate() {

        },

        afterUpdate() {
            this.$emit('input', this.item.data())
        }
    },
};
